import { parsePhoneNumberFromString } from "libphonenumber-js";
import numeral from "numeral";

export function randomId(length: number) {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  const charactersLength = characters.length;
  let result = "";
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
export function formatPhone(phone: string) {
  if (!phone) return null;
  const parsed = parsePhoneNumberFromString(phone, "US");
  if (parsed) return parsed.formatNational();
  return phone;
}
export function fileExt(fileName: string) {
  return fileName
    .slice(((fileName.lastIndexOf(".") - 1) >>> 0) + 2)
    .toLowerCase();
}
export function fileIsImage(fileName: string) {
  const ext = fileExt(fileName);
  const arr = [
    "jpg",
    "jpeg",
    "tiff",
    "gif",
    "bmp",
    "png",
    "webp",
    "svg",
    "ai",
    "eps",
  ];
  return arr.indexOf(ext) >= 0;
}
export function fileIcon(fileName: string) {
  if (fileIsImage(fileName)) {
    return "far fa-file-image";
  } else {
    const ext = fileExt(fileName);
    switch (ext) {
      case "doc":
      case "docx":
        return "far fa-file-word";
      case "xls":
      case "xlsx":
        return "far fa-file-excel";
      case "ppt":
      case "pptx":
        return "far fa-file-powerpoint";
      case "pdf":
        return "far fa-file-pdf";
      case "txt":
        return "far fa-file-alt";
      case "zip":
        return "far fa-file-archive";
      case "avi":
      case "wmv":
      case "mov":
      case "qt":
      case "flv":
      case "swf":
      case "mpg":
      case "mpe":
      case "mpv":
      case "mp2":
      case "mp4":
      case "m4p":
      case "m4v":
      case "ogg":
      case "mpeg":
      case "webm":
        return "far fa-file-video";
      case "csv":
        return "fas fa-file-csv";
      default:
        return "far fa-file";
    }
  }
}
export function fileSize(size: number) {
  return numeral(size).format("0.00 b");
}
export function isEmail(email: string) {
  // eslint-disable-next-line
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
export function isPhone(phone: string) {
  // eslint-disable-next-line
  const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
  return re.test(String(phone).toLowerCase());
}
export function filterOn(filter: any): boolean {
  let on = false;
  if (Array.isArray(filter)) {
    if (filter.length) on = true;
  } else if (typeof filter === "object") {
    for (const prop in filter) {
      const value = filter[prop];
      if (Array.isArray(value)) {
        if (value.length) {
          on = true;
          break;
        }
      } else if (typeof value === "object") {
        on = filterOn(value);
      } else if (value) {
        on = true;
        break;
      }
    }
  } else if (filter) {
    on = true;
  }
  return on;
}
export function detectUrl(text: string) {
  const regex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
  return text.replace(regex, (url) => {
    return `<a target="_blank" href="${url}">${url}</a>`;
  });
}
// CALLS
export function getCallFromIcon(fromType: string): string {
  switch (fromType) {
    case "MOBILE":
      return "fa fa-mobile-alt";
    case "LANDLINE":
      return "fa fa-home";
    case "VOIP":
      return "fa fa-ethernet";
    default:
      return "fa fa-question";
  }
}
export function getCallOriginIcon(origin: string): string {
  switch (origin) {
    case "CALL":
      return "fa fa-phone-alt";
    case "SMS":
      return "fa fa-comment";
    case "WEB":
      return "fab fa-edge-legacy";
    default:
      return "fa fa-question";
  }
}
//